module.exports = __webpack_public_path__ + "img/digitalIdentity3.741133c0.png";